import { render } from "./ChangePassword2.vue?vue&type=template&id=e9036ac0&scoped=true"
import script from "./ChangePassword2.vue?vue&type=script&lang=js"
export * from "./ChangePassword2.vue?vue&type=script&lang=js"

import "./ChangePassword2.vue?vue&type=style&index=0&id=e9036ac0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9036ac0"]])

export default __exports__